import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GwcApiConnService } from './gwc-api-conn.service';
import { InstitutionQualificationRegalia } from './types/institution-qualification-regalia.types';

@Injectable({
	providedIn: 'root'
})
export class GwcApiInstitutionQualificationRegaliaService {



	constructor(
		private _gwcApiConn: GwcApiConnService
	) {

	}


	public get(institution_qualification_id: string[]): Observable<InstitutionQualificationRegalia[]> {
		return this._gwcApiConn.request('GET', ['InstitutionQualificationRegalia'], { institution_qualification_id: institution_qualification_id.join(',')}) as Observable<InstitutionQualificationRegalia[]>;
	}

	public details(institution_qualification_regalia_id: string): Observable<InstitutionQualificationRegalia> {
		return this._gwcApiConn.request('GET', ['InstitutionQualificationRegalia', institution_qualification_regalia_id]) as Observable<InstitutionQualificationRegalia>
	}

	public getRegalia(institution_qualification_id: string):  Observable<InstitutionQualificationRegalia[]> {
		return this._gwcApiConn.request('GET', ['InstitutionQualification', institution_qualification_id, 'regalia'] ) as Observable<InstitutionQualificationRegalia[]>
	}



}
